import React from 'react';
import Box from '@mui/material/Box';
import { MenuComponent } from '../Menu';
import NavBar from '../Navbar/Navbar';

// Reusable responsive sidebar width configuration
export const SIDEBAR_WIDTHS = {
  xs: { collapsed: '60px', expanded: '220px' },
  sm: { collapsed: '70px', expanded: '240px' },
  md: { collapsed: '7%', expanded: '17.5%' },
  lg: { collapsed: '7%', expanded: '17.5%' },
};

const MainLayout = ({ children, collapsed, setCollapsed }) => {
  return (
    <Box sx={{ display: 'flex', height: '100vh', overflow: 'hidden' }}>
      {/* Sidebar */}
      <Box
        sx={{
          width: {
            xs: collapsed
              ? SIDEBAR_WIDTHS.xs.collapsed
              : SIDEBAR_WIDTHS.xs.expanded,
            sm: collapsed
              ? SIDEBAR_WIDTHS.sm.collapsed
              : SIDEBAR_WIDTHS.sm.expanded,
            md: collapsed
              ? SIDEBAR_WIDTHS.md.collapsed
              : SIDEBAR_WIDTHS.md.expanded,
            lg: collapsed
              ? SIDEBAR_WIDTHS.lg.collapsed
              : SIDEBAR_WIDTHS.lg.expanded,
          },
          flexShrink: 0,
          transition: 'width 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        }}
      >
        <MenuComponent collapsed={collapsed} setCollapsed={setCollapsed} />
      </Box>

      {/* Main Content Area */}
      <Box
        sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          minWidth: 0,
          overflow: 'auto',
          height: '100vh',
        }}
      >
        <NavBar />
        {children}
      </Box>
    </Box>
  );
};

export default MainLayout;
